import { DataSources } from "@/models/Message";
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Link,
  makeStyles,
  Text,
  tokens,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import React from "react";
import ReactMarkdown from "react-markdown";

type Props = {
  dataSources: DataSources;
};

export const DataSourceFAQ: React.FC<Props> = ({ dataSources }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Text className={classes.heading}>参照元</Text>
      <div className={classes.sourceListWrapper}>
        {dataSources.map((dataSource) => {
          return (
            <>
              <Text>{dataSource.section}</Text>

              <Dialog modalType="modal">
                <DialogTrigger disableButtonEnhancement>
                  <Link as="a" className={classes.sourceSection}>
                    {dataSource.title}
                  </Link>
                </DialogTrigger>
                <DialogSurface>
                  <DialogBody>
                    <DialogTitle
                      action={
                        <DialogTrigger action="close">
                          <Button
                            appearance="subtle"
                            aria-label="close"
                            icon={<Dismiss24Regular />}
                          />
                        </DialogTrigger>
                      }
                    >
                      {dataSource.title}
                    </DialogTitle>
                    <DialogContent>
                      <ReactMarkdown
                        components={{
                          a: (props) => <a {...props} target="_blank" rel="noopener noreferrer" />,
                        }}
                      >
                        {dataSource.content}
                      </ReactMarkdown>
                    </DialogContent>
                  </DialogBody>
                </DialogSurface>
              </Dialog>
            </>
          );
        })}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalXS,
  },
  heading: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
  sourceListWrapper: {
    marginTop: tokens.spacingVerticalXS,
    display: "grid",
    rowGap: tokens.spacingVerticalS,
    columnGap: tokens.spacingHorizontalS,
    alignItems: "start",
    gridTemplateColumns: "auto 1fr",
  },
  sourceSection: {
    display: "block",
    minWidth: "50px",
    verticalAlign: "top",
    wordBreak: "break-all",
  },
});
